import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { EmptyState } from "@/components/common/EmptyState";
import { MessageSquare } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function MessagesList() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/bookings").then((r) => {
      const bs = (r.data.items || []).filter((b) => b.athlete_id && b.ballboy_id);
      setItems(bs);
    });
  }, []);

  if (items.length === 0)
    return (
      <EmptyState
        icon={MessageSquare}
        title="No active chats"
        description="Once a ball boy accepts a booking, you'll be able to chat here."
      />
    );

  return (
    <div className="space-y-2">
      <h2 className="text-xl font-semibold bb-display">Messages</h2>
      {items.map((b) => {
        const other = user?.role === "athlete" ? b.counterpart : b.counterpart;
        return (
          <Link
            key={b.id}
            to={`/messages/${b.id}`}
            className="block rounded-xl border border-border bg-card p-3 hover:bg-muted/60"
            data-testid="messages-thread-link"
          >
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-full overflow-hidden bg-primary/10 text-primary grid place-items-center font-semibold">
                {other?.photo ? <img src={other.photo} alt="" className="h-full w-full object-cover" /> : (other?.name?.[0]?.toUpperCase() || "?")}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium">{other?.name}</div>
                <div className="text-xs text-muted-foreground truncate capitalize">{b.sport} · {b.status}</div>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
